module.exports = __webpack_public_path__ + "static/media/Dan Isaacs.b39f9073.jpg";